<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="接口模板">
                  <el-input style="width: 177px" v-model="queryForm.templateName"></el-input>
              </el-form-item>
              <el-form-item label="模板状态">
<!--                  <el-input  v-model="queryForm.templateStatus"></el-input>-->
                    <el-select style="width: 177px" clearable size="small" v-model="queryForm.templateStatus" placeholder="请选择">
                        <el-option
                          label="审核中"
                          :value="1"
                        ></el-option>
                        <el-option
                            label="审核通过"
                            :value="2"
                        ></el-option>
                        <el-option
                            label="审核失败"
                            :value="3"
                        ></el-option>
                    </el-select>
              </el-form-item>
              <el-form-item label="所属用户">
<!--                  <el-input style="width: 177px" v-model="queryForm.templateUserId"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择用户" labelName="userName"
                               labelValue="userId" :value="queryForm.templateUserId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSeachUser" :columns="TEMPLATEUSER_code" :searchs="TEMPLATEUSER_search" dataListUrl="/api/user/findList" entityBeanName="apiUser" queryEntityUrl="/api/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="所属签名">
<!--                  <el-input style="width: 177px" v-model="queryForm.accountId"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择签名" labelName="smsSign"
                               labelValue="accountId" :value="queryForm.accountId" :limit='1' size='small' placeholder='请选择签名'
                               @getValue="getSeachUser1" :columns="SMSAPIACCOUNT_code" :searchs="SMSAPIACCOUNT_search" dataListUrl="/api/smsapiaccount/findList" entityBeanName="apiSmsApiaccount" queryEntityUrl="/api/smsapiaccount/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getApiSmsTemplateList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addApiSmsTemplate"
        >添加模板</el-button>
         <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openAccountDialog"
        >签名管理</el-button>
          <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              @click="openApiDialog"
          >接口管理</el-button>
          <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              @click="openSmsDialog"
          >发送记录</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editApiSmsTemplate(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteApiSmsTemplate(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshApiSmsTemplateList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="apiSmsTemplateList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="templateCustomerName"
            label="模板名称"
            width="180"
        > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="accountId"
            label="所属签名"
            width="180"
        >
            <template slot-scope="scope">
                <div v-if="scope.row.accountId && scope.row.templateApiaccount">
                    <div style="text-align: left">短信签名:{{scope.row.templateApiaccount.smsSign}}</div>
                    <div style="text-align: left">短信类型:{{scope.row.templateApiaccount.smsType == 1 ? '商务' : '接口'}}</div>
                    <div style="text-align: left">发送类型:{{scope.row.templateApiaccount.sendType == 1 ? '即时发送' : '等待审核后发送'}}</div>
                    <div style="text-align: left">接口类型:{{scope.row.templateApiaccount.smsApiType == 1 ? '验证码' : (scope.row.templateApiaccount.smsApiType == 2 ? '通知' : '广告')}}</div>
                </div>
                <span v-else>--</span>
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="templateName"
        label="接口模板"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="templateContent"
        label="模板内容"
        width="180"
      > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="templateStatus"
            label="审核状态"
            width="180"
        >
            <template slot-scope="scope">
                <el-tag v-if="scope.row.templateStatus == 1" type="warning">审核中</el-tag>
                <el-tag v-else-if="scope.row.templateStatus == 2" type="success">已通过</el-tag>
                <el-tag v-else-if="scope.row.templateStatus == 3" type="danger">审核失败</el-tag>
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="templateRemark"
        label="备注"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="templateAddTimeFormatter"
        label="添加时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="templateUserId"
        label="所属用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.templateUserId && scope.row.templateUser">
                  <div style="text-align: left">用户账号:{{scope.row.templateUser.userName}}</div>
                  <div style="text-align: left">用户号码:{{scope.row.templateUser.userMobile}}</div>
                  <div style="text-align: left">用户状态:{{scope.row.templateUser.userStatus == 0 ? '正常' : '冻结'}}</div>
              </div>
              <span v-else>--</span>
          </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkApiSmsTemplate(scop.row.templateId)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editApiSmsTemplate(scop.row.templateId)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteApiSmsTemplate(scop.row.templateId)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="apiSmsTemplateStates[apiSmsTemplateState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="apiSmsTemplate"
          ref="apiSmsTemplateForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
            <el-form-item
                label="模板名称"
                prop="templateCustomerName"
                v-if="apiSmsTemplateState == 'check'">
                <el-input
                    size="small"
                    style="width: 177px"
                    v-model="apiSmsTemplate.templateCustomerName"
                    :disabled="apiSmsTemplateState == 'check'"
                ></el-input>
            </el-form-item>
          <el-form-item
            label="模板内容"
            prop="templateContent"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsTemplate.templateContent"
              :disabled="apiSmsTemplateState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="备注"
            prop="templateRemark"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsTemplate.templateRemark"
              :disabled="apiSmsTemplateState == 'check'"
            ></el-input>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="添加时间"-->
<!--            prop="templateAddTime"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="apiSmsTemplate.templateAddTime"-->
<!--              :disabled="apiSmsTemplateState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="模板状态"
            prop="templateStatus"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="apiSmsTemplate.templateStatus"-->
<!--              :disabled="apiSmsTemplateState == 'check'"-->
<!--            ></el-input>-->
              <el-select style="width: 177px" :disabled="apiSmsTemplateState == 'check'" clearable size="small" v-model="apiSmsTemplate.templateStatus" placeholder="请选择">
                  <el-option
                      label="审核中"
                      :value="1"
                  ></el-option>
                  <el-option
                      label="审核通过"
                      :value="2"
                  ></el-option>
                  <el-option
                      label="审核失败"
                      :value="3"
                  ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="所属用户"
            prop="templateUserId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="apiSmsTemplate.templateUserId"-->
<!--              :disabled="apiSmsTemplateState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择用户" labelName="userName" :disabled="apiSmsTemplateState == 'check'"
                           labelValue="userId" :value="apiSmsTemplate.templateUserId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getUser" :columns="TEMPLATEUSER_code" :searchs="TEMPLATEUSER_search" dataListUrl="/api/user/findList" entityBeanName="apiUser" queryEntityUrl="/api/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="所属签名"
            prop="accountId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="apiSmsTemplate.accountId"-->
<!--              :disabled="apiSmsTemplateState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择签名" labelName="smsSign" :disabled="apiSmsTemplateState == 'check'"
                           labelValue="accountId" :value="apiSmsTemplate.accountId" :limit='1' size='small' placeholder='请选择签名'
                           @getValue="getUser1" :columns="SMSAPIACCOUNT_code" :searchs="SMSAPIACCOUNT_search" dataListUrl="/api/smsapiaccount/findList" entityBeanName="apiSmsApiaccount" queryEntityUrl="/api/smsapiaccount/get">
              </GridSelectU>
          </el-form-item>
            <el-form-item
                label="接口模板"
                prop="templateName"
            >
                <el-input
                    size="small"
                    style="width: 177px"
                    v-model="apiSmsTemplate.templateName"
                    :disabled="apiSmsTemplateState == 'check'"
                ></el-input>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="apiSmsTemplateState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
      <!--   签名管理   -->
      <el-drawer
          title="签名管理"
          :visible.sync="showAccountDialog"
          direction="rtl"
          size="70%"
          :before-close="closeAccountDialog">
          <ApiSmsApiaccount ref="account"></ApiSmsApiaccount>
      </el-drawer>
      <!--   接口管理   -->
      <el-drawer
          title="接口管理"
          :visible.sync="showApiDialog"
          direction="rtl"
          size="70%"
          :before-close="closeApiDialog">
          <ApiSmsApi ref="api"></ApiSmsApi>
      </el-drawer>
      <!--   发送记录   -->
      <el-drawer
          title="发送记录"
          :visible.sync="showSmsDialog"
          direction="rtl"
          size="70%"
          :before-close="closeSmsDialog">
          <ApiSmsSend ref="sms"></ApiSmsSend>
      </el-drawer>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import ApiSmsApiaccount from '@/components/api/ApiSmsApiaccount.vue';
import ApiSmsApi from '@/components/api/ApiSmsApi.vue';
import ApiSmsSend from '@/components/api/ApiSmsSend.vue';
import GridSelectU from '@/components/gridselect/index.vue';
import { SMSAPIACCOUNT, SMSAPIACCOUNT_SEARCH, TEMPLATEUSER, TEMPLATEUSER_SEARCH } from '@/utils/constant';


export default {
    components: {
        GridSelectU,
        ApiSmsApiaccount,
        ApiSmsApi,
        ApiSmsSend,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetApiSmsTemplateList();
                    this.getApiSmsTemplateList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetApiSmsTemplateList();
                    this.getApiSmsTemplateList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     templateName: '', //模板名称第三方的比如阿里云里面的模板名称
                     templateContent: '', //模板内容
                     templateRemark: '', //备注
                     templateAddTime: '', //添加时间
                     templateStatus: '', //模板状态1 审核中  2 已通过
                     templateUserId: '', //模板隶属用户
                     accountId: '', //所属签名
                     templateCustomerName: '', //自己网站的，给客户拷贝使用的
                },
                TEMPLATEUSER_code: TEMPLATEUSER,
                TEMPLATEUSER_search: TEMPLATEUSER_SEARCH,
                SMSAPIACCOUNT_code: SMSAPIACCOUNT,
                SMSAPIACCOUNT_search: SMSAPIACCOUNT_SEARCH,
                showAccountDialog: false,
                showApiDialog: false,
                showSmsDialog: false,

                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                apiSmsTemplateState: 'add',
                apiSmsTemplateStates: {
                    add: '新建短信模板',
                    check: '查看短信模板',
                    edit: '修改短信模板'
                },

                multipleSelection: [],
                apiSmsTemplateList: [],
                apiSmsTemplate: {
                    templateName: '', //模板名称第三方的比如阿里云里面的模板名称
                    templateContent: '', //模板内容
                    templateRemark: '', //备注
                    templateAddTime: '', //添加时间
                    templateStatus: '', //模板状态1 审核中  2 已通过
                    templateUserId: '', //模板隶属用户
                    accountId: '', //所属签名
                    templateCustomerName: '', //自己网站的，给客户拷贝使用的
                },
                btnLoading: false,

                rules: {
                    templateName: [{ required: true, message: '部分接口需要指定模板名称才可以发送', trigger: 'blur' }],
                    templateContent: [{ required: true, message: '模板内容不能为空', trigger: 'blur' }],
                    templateRemark: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
                    templateAddTime: [{ required: true, message: '添加时间不能为空', trigger: 'blur' }],
                    templateStatus: [{ required: true, message: '模板状态不能为空', trigger: 'blur' }],
                    templateUserId: [{ required: true, message: '模板隶属用户不能为空', trigger: 'blur' }],
                    accountId: [{ required: true, message: '所属签名不能为空', trigger: 'blur' }],
                    templateCustomerName: [{ required: true, message: '模板名称不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getApiSmsTemplateList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetApiSmsTemplateList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.apiSmsTemplateList = [];
            },
            openAccountDialog(){
                this.showAccountDialog = true;
                this.$nextTick(()=>{
                    this.$refs.account.init();
                })
            },
            closeAccountDialog(){
                this.showAccountDialog = false
            },
            openApiDialog(){
                this.showApiDialog = true;
                this.$nextTick(()=>{
                    this.$refs.api.init();
                })
            },
            closeApiDialog(){
                this.showApiDialog = false
            },
            openSmsDialog(){
                this.showSmsDialog = true;
                this.$nextTick(()=>{
                    this.$refs.sms.init();
                })
            },
            closeSmsDialog(){
                this.showSmsDialog = false
            },
            getUser(value){
                this.apiSmsTemplate.templateUserId = value
            },
            getSeachUser(value){
                this.queryForm.templateUserId = value
            },
            getUser1(value){
                this.apiSmsTemplate.accountId = value
            },
            getSeachUser1(value){
                this.queryForm.accountId = value
            },
            resetDialog() {
                this.apiSmsTemplateState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      templateName: '', //模板名称第三方的比如阿里云里面的模板名称
                      templateContent: '', //模板内容
                      templateRemark: '', //备注
                      templateAddTime: '', //添加时间
                      templateStatus: '', //模板状态1 审核中  2 已通过
                      templateUserId: '', //模板隶属用户
                      accountId: '', //模板id
                      templateCustomerName: '', //自己网站的，给客户拷贝使用的
                };
                this.getApiSmsTemplateList();
            },
            closeDialog() {
                this.showDialog = false
                this.apiSmsTemplate = {
                      templateName: '', //模板名称第三方的比如阿里云里面的模板名称
                      templateContent: '', //模板内容
                      templateRemark: '', //备注
                      templateAddTime: '', //添加时间
                      templateStatus: '', //模板状态1 审核中  2 已通过
                      templateUserId: '', //模板隶属用户
                      accountId: '', //模板id
                      templateCustomerName: '', //自己网站的，给客户拷贝使用的
                };
            },
            submitForm() {
                if (this.apiSmsTemplateState == 'add') {
                    this.$refs.apiSmsTemplateForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/api/smstemplate/add`,{ ...this.apiSmsTemplate }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetApiSmsTemplateList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.apiSmsTemplateState == 'edit') {
                    this.$refs.apiSmsTemplateForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.apiSmsTemplate.templateUser
                            delete this.apiSmsTemplate.templateApiaccount
                            post(`/api/smstemplate/edit`,{ ...this.apiSmsTemplate }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetApiSmsTemplateList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addApiSmsTemplate() {
                this.showDialog = true;
                this.apiSmsTemplateState = 'add';
            },
            checkApiSmsTemplate(apiSmsTemplateId) {
                console.log(apiSmsTemplateId);
                this.currentApiSmsTemplateId = apiSmsTemplateId;

                this.getApiSmsTemplateById();
                this.showDialog = true;
                this.apiSmsTemplateState = 'check';
            },
            editApiSmsTemplate(apiSmsTemplateId) {
                console.log('apiSmsTemplate', apiSmsTemplateId);
                if (apiSmsTemplateId) {
                    this.currentApiSmsTemplateId = apiSmsTemplateId;
                    this.getApiSmsTemplateById();
                } else {
                    this.apiSmsTemplate = { ...this.apiSmsTemplate, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.apiSmsTemplateState = 'edit';
            },
            deleteApiSmsTemplate(apiSmsTemplateId) {
                let ids = '';
                if (apiSmsTemplateId) {
                    ids = apiSmsTemplateId;
                } else {
                    ids = this.multipleSelection.map((apiSmsTemplate) => apiSmsTemplate.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/api/smstemplate/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetApiSmsTemplateList();
                                this.getApiSmsTemplateList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshApiSmsTemplateList() {
                this.resetApiSmsTemplateList();
                this.getApiSmsTemplateList();
            },
            getApiSmsTemplateList(query = {}) {
                this.loading = true;
                get(`/api/smstemplate/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.apiSmsTemplateList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getApiSmsTemplateById() {
                get(`/api/smstemplate/get`,{ id: this.currentApiSmsTemplateId }).then((res) =>{
                    if(res.success){
                      this.apiSmsTemplate = { ...this.apiSmsTemplate, ...res.apiSmsTemplate };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportApiSmsTemplateList() {
                //this.btnLoading = true;
                exprotExcel(`/api/smstemplate/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/api/smstemplate/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/api/smstemplate/importData`,formData);
              this.refreshApiSmsTemplateList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getApiSmsTemplateList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getApiSmsTemplateList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>